// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('underscore');
const { TrelloStorage } = require('@trello/storage');
const { verticals } = require('app/scripts/views/onboarding/constants');

const getSavedInspirationBoards = () => {
  return TrelloStorage.get('inspiration-boards') || {};
};

const isInspirationBoard = (boardId) => {
  const savedInspoBoards = getSavedInspirationBoards();
  for (const inspoBoardId in savedInspoBoards) {
    const myBoardId = savedInspoBoards[inspoBoardId];
    if (myBoardId === boardId) {
      return true;
    }
  }
  return false;
};

const getInspoBoardId = (boardId) => {
  const savedInspoBoards = getSavedInspirationBoards();
  for (const inspoBoardId in savedInspoBoards) {
    const myBoardId = savedInspoBoards[inspoBoardId];
    if (myBoardId === boardId) {
      return inspoBoardId;
    }
  }
};

const getVertical = (boardId) => {
  const thisInspoBoardId = getInspoBoardId(boardId);
  for (const vertical in verticals) {
    const def = verticals[vertical];
    for (const lang in def.inspirationBoards) {
      const board = def.inspirationBoards[lang];
      if (board.id === thisInspoBoardId) {
        return vertical;
      }
    }
  }
  return null;
};

const saveBoard = (id, boardId) => {
  const savedInspoBoards = getSavedInspirationBoards();

  return TrelloStorage.set(
    'inspiration-boards',
    _.extend({}, savedInspoBoards, {
      [id]: boardId,
    }),
  );
};

const removeBoard = (boardId) => {
  const savedInspoBoards = getSavedInspirationBoards();
  return (() => {
    const result = [];
    for (const inspoBoardId in savedInspoBoards) {
      const myBoardId = savedInspoBoards[inspoBoardId];
      if (myBoardId === boardId) {
        delete savedInspoBoards[inspoBoardId];
        result.push(TrelloStorage.set('inspiration-boards', savedInspoBoards));
      } else {
        result.push(undefined);
      }
    }
    return result;
  })();
};

module.exports = {
  isInspirationBoard,
  removeBoard,
  getVertical,
  getInspoBoardId,
  getSavedInspirationBoards,
  saveBoard,
};
